import { useOktaAuth } from '@okta/okta-react';
import { getConfig } from '@tcs/client-portal/config/configService';
import axios from 'axios';
import { useMutation } from 'react-query';

export interface SigningRequest {
  email: string;
  name: string;
  clientUserId: string;
  tabs?: {
    textTabs?: Array<{
      tabLabel: string;
      value: string;
    }>;
    checkboxTabs?: Array<{
      tabLabel: string;
      selected: string;
    }>;
    radioGroupTabs?: Array<{
      groupName: string;
      radios: Array<{
        value: string;
        selected: string;
      }>;
    }>;
  };
}

export interface SigningResponse {
  url: string;
  envelopeId: string;
}

export const useTransfersInRequest = () => {
  const { oktaAuth } = useOktaAuth();

  return useMutation<SigningResponse, Error, SigningRequest>(
    async (signingRequest: SigningRequest) => {
      const config = getConfig();
      const tokens = await oktaAuth.tokenManager.getTokens();
      const token = tokens.accessToken?.accessToken;

      const response = await axios.post(
        `${config.API_BASE_URL}/transfersin/signingrequest`,
        signingRequest,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-tcs-authorization': token,
          },
        }
      );

      return response.data;
    }
  );
};

export default useTransfersInRequest;
